import {
  AlignLeft,
  FileText,
  Image as ImageIcon,
  type LucideIcon,
  Mic,
  Music,
  Video,
} from "lucide-react";
import type { LibraryItemKind } from "@/lib/library";

/** The icon a material of the content library is shown with, by its kind. */
export const KIND_ICONS: Record<LibraryItemKind, LucideIcon> = {
  text: AlignLeft,
  photo: ImageIcon,
  video: Video,
  voice: Mic,
  audio: Music,
  document: FileText,
};
